import React, { Component } from 'react';
import { withI18n } from 'react-i18next';
import PropTypes from 'prop-types';
import CONFIGS from 'configs';
import ForgotPasswordForm from '../forms/ForgotPasswordForm';
import ResetPasswordForm from '../forms/ResetPasswordForm';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enterCode: false,
      email: '',
    };
  }

  nextAction = (email) => {
    this.setState({
      enterCode: true,
      email,
    });
  };

  render() {
    const { t, authState, onStateChange } = this.props;
    const { enterCode, email } = this.state;
    if (authState !== 'forgotPassword') return null;

    const { logo } = CONFIGS;

    return (
      <div className="container h-100 mt-5 pt-5">
        <div className="row h-100 justify-content-center align-items-center">
          <div className="form-signin">
            <div className="text-center mb-3">
              <img src={logo} alt="" width="92" height="92" />
              <h1 className="h3 m-1 font-weight-bold">
                {!enterCode
                  ? t('oops_lost_something')
                  : t('enter_new_password')}
              </h1>
              <small>
                {!enterCode
                  ? t('forgot_password_explain')
                  : t('enter_new_password_explain')}
              </small>
            </div>
            {!enterCode ? (
              <ForgotPasswordForm next={this.nextAction} />
            ) : (
              <ResetPasswordForm email={email} onStateChange={onStateChange} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

ForgotPassword.propTypes = {
  t: PropTypes.func.isRequired,
  authState: PropTypes.string.isRequired,
  onStateChange: PropTypes.func.isRequired,
};

export default withI18n()(ForgotPassword);
